import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

let rmRequiredFlags = ['ActivitySet', 'BASet', 'InventorySet', 'JobRolesSet', 'Policy001Set', 'Policy002Set', 'Policy003Set', 'Policy004Set', 'Policy005Set', 'Policy006Set', 'Policy007Set', 'Policy008Set', 'Policy009Set', 'Policy010Set', 'Policy011Set', 'Policy012Set', 'Policy013Set', 'Policy014Set', 'Policy015Set', 'Policy016Set', 'Policy017Set', 'Policy018Set', 'Policy019Set', 'Policy020Set', 'POSet', 'WorkforceSet'];

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [{
            path: '/',
            redirect: '/dashboard',
            name: 'Home',
            component: () =>
                import ('@/views/containers/DefaultContainer'),
            children: [{
                path: 'dashboard',
                name: 'Dashboard',
                component: () =>
                    import ('@/views/Dashboard'),
                meta: { requiresLogin: true, videoId: '411793674' }
            }, {
                path: 'activity-list',
                name: 'ActivityList',
                component: () =>
                    import ('@/views/ActivityList'),
                meta: { requiresLogin: true, title: 'Activity Review', videoId: '411785199', bodyClass: 'list-view' }
            }, {
                path: 'activity-edit/:id?',
                props: true,
                name: 'ActivityEdit',
                component: () =>
                    import ('@/views/ActivityEdit'),
                meta: { requiresLogin: true, title: 'Activity Edit', videoId: '411793895', requiredFlags: ['InventorySet', 'Policy013Set', 'WorkforceSet'] }
            }, {
                path: 'ba-list',
                name: 'BAList',
                component: () =>
                    import ('@/views/BAList'),
                meta: { requiresLogin: true, title: 'Business Associates', videoId: '411783701', bodyClass: 'list-view' }
            }, {
                path: 'ba-edit/:id?',
                props: true,
                name: 'BAEdit',
                component: () =>
                    import ('@/views/BAEdit'),
                meta: { requiresLogin: true, title: 'Business Associate', videoId: '411793822', requiredFlags: ['POSet'] }
            }, {
                path: 'inventory-list',
                name: 'InventoryList',
                component: () =>
                    import ('@/views/InventoryList'),
                meta: { requiresLogin: true, title: 'ePHI Inventory', videoId: '411783543', bodyClass: 'list-view' }
            }, {
                path: 'inventory-edit/:id?',
                props: true,
                name: 'InventoryEdit',
                component: () =>
                    import ('@/views/InventoryEdit'),
                meta: { requiresLogin: true, title: 'Edit ePHI Inventory', videoId: '411783603', requiredFlags: ['POSet', 'WorkforceSet'] }
            }, {
                path: 'policy-list',
                name: 'PolicyList',
                component: () =>
                    import ('@/views/PolicyList'),
                meta: { requiresLogin: true, title: 'Policies & Procedures', videoId: '411783867', bodyClass: 'list-view' }
            }, {
                path: 'policy-edit/:id?',
                props: true,
                name: 'PolicyEdit',
                component: () =>
                    import ('@/views/PolicyEdit'),
                meta: { requiresLogin: true, title: 'Edit Policies & Procedures', videoId: '411783867', requiredFlags: ['POSet'] }
            }, {
                path: 'practice',
                redirect: '/',
                name: 'Practice',
                component: {
                    render(c) { return c('router-view') }
                },
                meta: { requiresLogin: true },
                children: [{
                    path: 'location',
                    name: 'Practice.Location',
                    component: () =>
                        import ( /* webpackChunkName: "group-practice" */ '@/views/Location'),
                    meta: { requiresLogin: true, title: 'Practice Location' }
                }, {
                    path: 'po',
                    name: 'Practice.PrivacyOfficer',
                    component: () =>
                        import ( /* webpackChunkName: "group-practice" */ '@/views/PrivacyOfficer'),
                    meta: { requiresLogin: true, title: 'Privacy Officer', videoId: '411783113' }
                }, {
                    path: 'roles',
                    name: 'Practice.Roles',
                    component: () =>
                        import ( /* webpackChunkName: "group-practice" */ '@/views/Roles'),
                    meta: { requiresLogin: true, title: 'Manage Workforce Roles', videoId: '411783247', requiredFlags: ['POSet'] }
                }, {
                    path: 'logbook',
                    name: 'Practice.Logbook',
                    component: () =>
                        import ( /* webpackChunkName: "group-practice" */ '@/views/Logbook'),
                    meta: { requiresLogin: true, title: 'Logbook', videoId: '411793770' }
                }]
            }, {
                path: 'profile',
                name: 'Profile',
                component: () =>
                    import ('@/views/Profile'),
                meta: { requiresLogin: true, title: 'Profile', videoId: '411782971' }
            }, {
                path: 'risk',
                redirect: '/risk/start',
                name: 'Risk',
                component: {
                    render(c) { return c('router-view') }
                },
                meta: { requiresLogin: true, title: 'Risk Management', bodyClass: 'list-view', requiredFlags: rmRequiredFlags },
                children: [{
                    path: 'start',
                    name: 'RiskList',
                    component: () =>
                        import ( /* webpackChunkName: "group-risk" */ '@/views/RiskList'),
                    meta: { requiresLogin: true, title: 'Risk Management', videoId: '411794908', bodyClass: 'list-view', requiredFlags: rmRequiredFlags }
                }, {
                    path: 'review',
                    name: 'RiskAnalysisReview',
                    component: () =>
                        import ( /* webpackChunkName: "group-risk" */ '@/views/RiskAnalysisReview'),
                    meta: { requiresLogin: true, title: 'Risk Management', videoId: '411785490', bodyClass: 'list-view', requiredFlags: rmRequiredFlags }
                }, {
                    path: 'threats',
                    name: 'RiskAnalysisThreats',
                    component: () =>
                        import ( /* webpackChunkName: "group-risk" */ '@/views/RiskAnalysisThreats'),
                    meta: { requiresLogin: true, title: 'Risk Management', videoId: '411785578', bodyClass: 'list-view', requiredFlags: rmRequiredFlags }
                }, {
                    path: 'level',
                    name: 'RiskAnalysisLevelList',
                    component: () =>
                        import ( /* webpackChunkName: "group-risk" */ '@/views/RiskAnalysisLevelList'),
                    meta: { requiresLogin: true, title: 'Risk Management', videoId: '411785663', bodyClass: 'list-view', requiredFlags: rmRequiredFlags }
                }, {
                    path: 'level/:id',
                    props: true,
                    name: 'RiskAnalysisLevel',
                    component: () =>
                        import ( /* webpackChunkName: "group-risk" */ '@/views/RiskAnalysisLevel'),
                    meta: { requiresLogin: true, title: 'Risk Management', videoId: '411785663', bodyClass: 'list-view', requiredFlags: rmRequiredFlags }
                }, {
                    path: 'report',
                    props: { id: null },
                    name: 'RiskAnalysisReport',
                    component: () =>
                        import ( /* webpackChunkName: "group-risk" */ '@/views/RiskAnalysisReport'),
                    meta: { requiresLogin: true, title: 'Risk Management', videoId: '411785768', bodyClass: 'list-view', requiredFlags: rmRequiredFlags }
                }, {
                    path: 'plan',
                    name: 'RiskPlanList',
                    component: () =>
                        import ( /* webpackChunkName: "group-risk" */ '@/views/RiskPlanList'),
                    meta: { requiresLogin: true, title: 'Risk Management', videoId: '411785860', bodyClass: 'list-view', requiredFlags: rmRequiredFlags }
                }, {
                    path: 'plan/:id',
                    props: true,
                    name: 'RiskPlan',
                    component: () =>
                        import ( /* webpackChunkName: "group-risk" */ '@/views/RiskPlan'),
                    meta: { requiresLogin: true, title: 'Risk Management', videoId: '411785860', bodyClass: 'list-view', requiredFlags: rmRequiredFlags }
                }, {
                    path: 'approve',
                    props: { id: null },
                    name: 'RiskPlanReport',
                    component: () =>
                        import ( /* webpackChunkName: "group-risk" */ '@/views/RiskPlanReport'),
                    meta: { requiresLogin: true, title: 'Risk Management', videoId: '411786024', bodyClass: 'list-view', requiredFlags: rmRequiredFlags }
                }]
            }, {
                path: 'forms',
                name: 'SampleForms',
                component: () =>
                    import ('@/views/SampleForms'),
                meta: { requiresLogin: true, title: 'Sample HIPAA Forms', videoId: '411786252', bodyClass: 'list-view' }
            }, {
                path: 'task-list',
                name: 'TaskList',
                component: () =>
                    import ('@/views/TaskList'),
                meta: { requiresLogin: true, title: 'Risk Mitigation Tasks', videoId: '411794991', bodyClass: 'list-view', requiredFlags: ['RMSet'] }
            }, {
                path: 'task-edit/:id?',
                props: true,
                name: 'TaskEdit',
                component: () =>
                    import ('@/views/TaskEdit'),
                meta: { requiresLogin: true, title: 'Edit Risk Mitigation Task', videoId: '411786151', requiredFlags: ['RMSet'] }
            }, {
                path: 'training-docs',
                name: 'TrainingDocs',
                component: () =>
                    import ('@/views/TrainingDocs'),
                meta: { requiresLogin: true, title: 'Training', videoId: '411784651', bodyClass: 'list-view', requiredFlags: ['POSet', 'Policy002Set', 'Policy003Set', 'Policy005Set', 'Policy009Set', 'Policy015Set', 'Policy017Set', 'Policy018Set', 'Policy020Set', 'WorkforceSet'] }
            }, {
                path: 'training-list',
                name: 'TrainingList',
                component: () =>
                    import ('@/views/TrainingList'),
                meta: { requiresLogin: true, title: 'Training Events', videoId: '411784808', bodyClass: 'list-view' }
            }, {
                path: 'training-edit/:id?',
                props: true,
                name: 'TrainingEdit',
                component: () =>
                    import ('@/views/TrainingEdit'),
                meta: { requiresLogin: true, title: 'Edit Training Event', videoId: '411784746' }
            }, {
                path: 'workforce-list',
                name: 'WorkforceList',
                component: () =>
                    import ('@/views/WorkforceList'),
                meta: { requiresLogin: true, title: 'Workforce', videoId: '411783479', bodyClass: 'list-view' }
            }, {
                path: 'workforce-edit/:id?',
                props: true,
                name: 'WorkforceEdit',
                component: () =>
                    import ('@/views/WorkforceEdit'),
                meta: { requiresLogin: true, title: 'Edit Workforce Member', videoId: '411783410', requiredFlags: ['JobRolesSet', 'POSet'] }
            }]
        },
        {
            path: '/account',
            redirect: '/login',
            name: 'Account',
            component: {
                render(c) { return c('router-view') }
            },
            children: [{
                path: '/login',
                props: true,
                name: 'Login',
                component: () =>
                    import ('@/views/account/Login')
            }, {
                path: '/register',
                name: 'Register',
                component: () =>
                    import ( /* webpackChunkName: "group-account" */ '@/views/account/Register')
            }, {
                path: '/confirm/:email/:codeParam?',
                props: true,
                name: 'Confirm',
                component: () =>
                    import ( /* webpackChunkName: "group-account" */ '@/views/account/Confirm')
            }, {
                path: '/forgot',
                name: 'ForgotPassword',
                component: () =>
                    import ( /* webpackChunkName: "group-account" */ '@/views/account/ForgotPassword')
            }, {
                path: '/forgot-confirm/:email/:codeParam?',
                props: true,
                name: 'ForgotConfirm',
                component: () =>
                    import ( /* webpackChunkName: "group-account" */ '@/views/account/ForgotConfirm')
            }]
        }, {
            path: '/setup',
            redirect: '/setup/location',
            name: 'Setup',
            component: () =>
                import ( /* webpackChunkName: "group-setup" */ '@/views/containers/SetupContainer'),
            children: [{
                path: 'location',
                name: 'Location',
                component: () =>
                    import ( /* webpackChunkName: "group-setup" */ '@/views/Location'),
                meta: { requiresLogin: true }
            }, {
                path: 'payment',
                name: 'SetupPayment',
                component: () =>
                    import ( /* webpackChunkName: "group-setup" */ '@/views/Payment'),
                meta: { requiresLogin: true }
            }]
        }, {
            path: '/renew',
            redirect: '/renew/payment',
            name: 'Renew',
            component: () =>
                import ( /* webpackChunkName: "group-setup" */ '@/views/containers/RenewContainer'),
            children: [{
                path: 'payment',
                name: 'RenewPayment',
                component: () =>
                    import ( /* webpackChunkName: "group-setup" */ '@/views/Payment'),
                meta: { requiresLogin: true }
            }]
        }, {
            path: '/print',
            redirect: '/',
            name: 'Print',
            component: () =>
                import ('@/views/containers/PrintContainer'),
            meta: { requiresLogin: true },
            children: [{
                path: 'policy-print/:id',
                props: true,
                name: 'Print.PolicyPrint',
                component: () =>
                    import ('@/views/PolicyPrint'),
                meta: { requiresLogin: true, bodyClass: 'list-view' }
            }, {
                path: 'policy-print-all',
                name: 'Print.PolicyPrintAll',
                component: () =>
                    import ('@/views/PolicyPrintAll'),
                meta: { requiresLogin: true, bodyClass: 'list-view' }
            }, {
                path: 'ra-print/:id',
                props: true,
                name: 'Print.RiskAnalysisReport',
                component: () =>
                    import ('@/views/RiskAnalysisReport'),
                meta: { requiresLogin: true, bodyClass: 'list-view' }
            }, {
                path: 'rm-print/:id',
                props: true,
                name: 'Print.RiskPlanReport',
                component: () =>
                    import ('@/views/RiskPlanReport'),
                meta: { requiresLogin: true, bodyClass: 'list-view' }
            }, {
                path: '/training-print/:type',
                props: true,
                name: 'Print.TrainingPrint',
                component: () =>
                    import ('@/views/TrainingPrint'),
                meta: { requiresLogin: true, bodyClass: 'list-view' }
            }]
        },
        // otherwise redirect to home
        {
            path: '*',
            redirect: '/'
        }
    ]
});

// check for login required
router.beforeEach((to, from, next) => {
    // log routing for debugging purposes
    console.log('Router: to[%s %s] from[%s %s]', to.name, to.path, from.name, from.path);

    // always clear error before navigate
    store.dispatch('alert/clear');

    // check if login is required
    if (to.matched.some(record => record.meta.requiresLogin)) {
        // this route requires login, verify user logged in
        if (!localStorage.userToken) {
            return next({ path: '/login', query: { redirect: to.fullPath } });
        }
    }

    // set required progress flags
    store.dispatch('progress/setRequiredFlags', to.meta.requiredFlags || []);

    // check for bodyClass in from route to remove
    if (from.meta.bodyClass) {
        console.log('Router: removing body class [%s]', from.meta.bodyClass);
        document.body.classList.remove(from.meta.bodyClass);
    }

    // check for bodyClass in to route to add
    if (to.meta.bodyClass) {
        console.log('Router: adding body class [%s]', to.meta.bodyClass);
        document.body.classList.add(to.meta.bodyClass);
    }

    // reset user when navigating to login or register
    if (to.name === 'Login' || to.name == 'Register') {
        const user = store.state.user.user;

        console.log('Router: resetting user');
        store.dispatch('user/reset');

        if (user) {
            console.log('Router: add user info to query');
            const inSetup = from.fullPath.indexOf('setup') !== -1;
            const inRenew = from.fullPath.indexOf('renew') !== -1;
            const redirect = inSetup || inRenew ? {} : { redirect: from.fullPath }; // only include redirect path if not in setup or renew

            return next({ path: to.path, query: {... { email: user }, ...redirect, ...to.params } });
        }
    }

    // check query string params for affiliate id
    if (to.query.hasOwnProperty('aid')) {
        localStorage.hmTimestamp = new Date();
        localStorage.hmAffiliate = to.query.aid; // cache in local storage
        console.log('Affiliate Id:', localStorage.hmAffiliate);
    }

    // check query string params for coupon code
    if (to.query.hasOwnProperty('coupon')) {
        localStorage.hmTimestamp = new Date();
        localStorage.hmCoupon = to.query.coupon; // cache in local storage
        console.log('Coupon code:', localStorage.hmCoupon);
    }

    return next(); // make sure to always call next()!
});

export default router